export default class ScrollTo {
    constructor(selector = '.scroll-to') {
        // Setup links, if any
        const el_links = document.querySelectorAll(selector);
        if (!el_links) return; // bail if no links

        el_links.forEach(el => {

            el.addEventListener('click', (event) => {
                event.preventDefault();

                let el_target = document.querySelector(el.getAttribute('data-el'));
                el_target.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            });

        });
    }
}